<template>
  <div>Your order will be on its way. Receipt of this purchase will be sent to your email</div>
</template>
<script>
export default {
  name: "PaymentSuccess",
  data() {
    return {
      
    };
  }
};
</script>
